<template>
  <!-- 郵送する書類を作った人に、封筒の宛名ラベルを勧める。
       今いる画面（完了画面・コンビニ印刷の QR）を残したいので別タブで開く -->
  <a
    :id="linkId"
    :href="href"
    target="_blank"
    rel="noopener"
    class="atena-suggest"
  >
    <img
      class="atena-suggest__img"
      src="/static/img/formats/sample/atena.png"
      alt=""
      aria-hidden="true"
    />
    <span class="atena-suggest__body">
      <span class="atena-suggest__title">封筒の宛名ラベルも作れます</span>
      <span class="atena-suggest__lead">{{ lead }}</span>
    </span>
    <span class="atena-suggest__cta">宛名ラベルを作る</span>
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  /** GTM の link_click で入口を区別する id */
  linkId: string
  /** 遷移先に付ける計測用の frm。GA4 の page_location で流入元を数える */
  frm: string
  lead: string
}>()

const href = computed(
  () => `/format/atena?frm=${encodeURIComponent(props.frm)}`
)
</script>

<style lang="scss" scoped>
$primary: #e3165c;
$deep-green: #004d40;
$border: #cfe3cc;
$bg: #f5faf4;
$note-color: #6b6b6b;

.atena-suggest {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  padding: 12px 14px;
  border: 1px solid $border;
  border-radius: 10px;
  background: $bg;
  color: $deep-green;
  text-align: left;
  text-decoration: none;

  /* グローバルの a:hover { opacity: 0.5 } を打ち消す */
  &:hover {
    opacity: 1;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: $deep-green;
    }
  }

  &:focus-visible {
    outline: 2px solid $primary;
    outline-offset: 2px;
  }

  &__img {
    flex: 0 0 auto;
    width: 56px;
    height: auto;
    border-radius: 4px;
  }

  &__body {
    display: flex;
    flex: 1 1 180px;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  &__title {
    font-size: 0.938rem;
    font-weight: bold;
    line-height: 1.4;
  }

  &__lead {
    font-size: 0.75rem;
    line-height: 1.5;
    color: $note-color;
  }

  &__cta {
    flex: 0 0 auto;
    padding: 6px 14px;
    border: 1px solid $deep-green;
    border-radius: 999px;
    font-size: 0.813rem;
    font-weight: bold;
    white-space: nowrap;
  }
}
</style>
